import React, { useEffect, useRef, useState } from 'react';
import PartnerItem from './PartenaireItem';

const VISIBLE_COUNT = 7;

function PartnerList({ partners, currentIndex, visible, disableTransition }) {
  const extended = [...partners, ...partners.slice(0, VISIBLE_COUNT)];
  const totalItems = extended.length;

  return (
    <div
      className="partenaires-list flexbox slick-slider"
      style={{
        width: '100%',
        overflow: 'hidden',
        margin: '0 auto',
        display: visible ? 'block' : 'none',
      }}
    >
      <div className="slick-list draggable" aria-live="polite" style={{ overflow: 'hidden' }}>
        <div
          className="slick-track"
          style={{
            transform: `translateX(-${(100 / totalItems) * currentIndex}%)`,
            transition: disableTransition ? 'none' : 'transform 0.3s ease-in-out',
            width: `${(totalItems / VISIBLE_COUNT) * 100}%`,
            display: 'flex',
          }}
        >
          {extended.map((partner, idx) => (
            <div
              key={idx}
              className="partenaires-item-big-ctn flexbox slick-slide"
              style={{ width: `${100 / totalItems}%` }}
            >
              <PartnerItem {...partner} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function PartnerCarousel({ partners }) {
  const [mainIndex, setMainIndex] = useState(0);
  const [cloneIndex, setCloneIndex] = useState(VISIBLE_COUNT);
  const [showClone, setShowClone] = useState(false);
  const [disableTransition, setDisableTransition] = useState(false);

  useEffect(() => {
    if (partners.length <= VISIBLE_COUNT) return;

    const maxIndex = partners.length + VISIBLE_COUNT - 2;
    const interval = setInterval(() => {
      setMainIndex((prev) => {
        if (prev + 1 >= maxIndex) {
          setCloneIndex(0);
          setShowClone(true);

          setTimeout(() => {
            setDisableTransition(true);
            setMainIndex(0);

            requestAnimationFrame(() => {
              setShowClone(false);
              setTimeout(() => setDisableTransition(false), 50);
            });
          }, 300);

          return prev;
        }
        return prev + 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [partners.length]);

  return (
    <>
      <PartnerList
        partners={partners}
        currentIndex={mainIndex}
        visible={!showClone}
        disableTransition={disableTransition}
      />
      <PartnerList
        partners={partners}
        currentIndex={cloneIndex}
        visible={showClone}
        disableTransition={false}
      />
    </>
  );
}

export default PartnerCarousel;
